import { DetailsBooking } from 'types';

export const showPaidByQantasTravelPass = (booking: DetailsBooking): boolean =>
  !!booking.transactions.find((item) => item.chargeBreakdown.qantasGroupCreditVoucher.paymentMethod);
